import React, { FC } from 'react';
import { I18n } from 'react-redux-i18n';

import BuyButton from '@ui/BuyButton';
import { browserHistory } from 'react-router';
import { getClassesForCssModule } from '@utils/customBEMHelper';
import ShopCard from '@ui/ShopCard';

import styles from './styles.module.scss';

const classes = getClassesForCssModule('free-shop-card', styles);

const FreeCard: FC = () => {
  return (
    <ShopCard
      title={I18n.t('shop.free.header')}
      body={
        <>
          <ol className={classes('list')}>
            <li>{I18n.t('shop.present.title')}</li>
            <li>{I18n.t('shop.present.desc')}</li>
          </ol>
          <br />
          <br />
          <span>
            {I18n.t('shop.present.noRestrictions')} <br />
            {I18n.t('shop.present.example')}
          </span>
          <BuyButton
            children={I18n.t('shop.present.inviteFriendBtn')}
            center
            className={classes('btn')}
            onClick={() => browserHistory.push('/i/invite')}
          />
        </>
      }
      color="green"
    />
  );
};

export default FreeCard;
